import { Component, VERSION } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent {

  version: string = "1.0.0";

  constructor() {
    fetch(window.location.origin + '/InfoDeploy.txt')
      .then(text => {  
        console.log(text);  
      })  
      .catch(error => {  
        console.error('Hubo un problema con la petición Fetch:', error);  
      }); 
  }

  // versionApp = `${environment.appVersion}`;
  versionApp = this.version;
  versionAngular = `${VERSION.major}.${VERSION.minor}.${VERSION.patch}`;
  
}
